/**
 * @voltxampere/ui — Capacitor (Kapasitör) · non-polarized parallel plates
 *
 * Two heavy vertical plates at x=16 / x=22 with leads coming in
 * from y=13. Polarized (electrolytic) variant is post-Sprint 12.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_IVORY, STROKE_WIDTH_HEAVY, STROKE_WIDTH_MAIN, VIEWBOX_DEFAULT, } from "./constants.js";
export const capacitor = {
    id: "capacitor",
    nameTr: "Kapasitör",
    nameEn: "Capacitor",
    shortcut: "C",
    category: "passive",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 0, y: 13, polarity: "bi" },
        { x: 40, y: 13, polarity: "bi" },
    ],
    defaultLabel: "C",
    defaultValue: "10µF",
    renderSVG: () => [
        `<line x1="0" y1="13" x2="16" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="16" y1="4" x2="16" y2="22" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_HEAVY)}"/>`,
        `<line x1="22" y1="4" x2="22" y2="22" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_HEAVY)}"/>`,
        `<line x1="22" y1="13" x2="40" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
    ].join(""),
};
//# sourceMappingURL=capacitor.js.map